import { render, staticRenderFns } from "./LiveVideoList.vue?vue&type=template&id=65bc81a4&scoped=true&"
import script from "./LiveVideoList.vue?vue&type=script&lang=js&"
export * from "./LiveVideoList.vue?vue&type=script&lang=js&"
import style0 from "./LiveVideoList.vue?vue&type=style&index=0&id=65bc81a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc81a4",
  null
  
)

export default component.exports